/**
 * @generated SignedSource<<6826b4d83f3a95fc56dcb3e1246dfe77>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateFirmPortalSettingsInput = {
  portalSubdomain?: string | null;
  portalCustomDomain?: string | null;
  portalSenderDomain?: string | null;
  portalReplyTo?: string | null;
  defaultShowInvoices?: boolean | null;
  defaultAllowFileUpload?: boolean | null;
  phaseStatusEnabled?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateFirmPortalSettingsMutation$variables = {
  input: UpdateFirmPortalSettingsInput;
};
export type updateFirmPortalSettingsMutation$data = {
  readonly updateFirmPortalSettings: {
    readonly firmPortalSettings: {
      readonly portalSubdomain: string | null;
      readonly portalCustomDomain: string | null;
      readonly portalReplyTo: string | null;
      readonly defaultAllowFileUpload: boolean | null;
      readonly phaseStatusEnabled: boolean | null;
    } | null;
  } | null;
};
export type updateFirmPortalSettingsMutation = {
  variables: updateFirmPortalSettingsMutation$variables;
  response: updateFirmPortalSettingsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateFirmPortalSettingsPayload",
    "kind": "LinkedField",
    "name": "updateFirmPortalSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FirmPortalSettings",
        "kind": "LinkedField",
        "name": "firmPortalSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "portalSubdomain",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "portalCustomDomain",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "portalReplyTo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defaultAllowFileUpload",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phaseStatusEnabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateFirmPortalSettingsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateFirmPortalSettingsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e010d56f836cd33f2a93b151375de61a",
    "id": null,
    "metadata": {},
    "name": "updateFirmPortalSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation updateFirmPortalSettingsMutation(\n  $input: UpdateFirmPortalSettingsInput!\n) {\n  updateFirmPortalSettings(input: $input) {\n    firmPortalSettings {\n      portalSubdomain\n      portalCustomDomain\n      portalReplyTo\n      defaultAllowFileUpload\n      phaseStatusEnabled\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bb7a3f0271568604a89b2eb1d9e23498";

export default node;
